import { render, staticRenderFns } from "./EstadoNovedadesShow.vue?vue&type=template&id=a8195628&scoped=true"
import script from "./EstadoNovedadesShow.vue?vue&type=script&lang=js"
export * from "./EstadoNovedadesShow.vue?vue&type=script&lang=js"
import style0 from "./EstadoNovedadesShow.vue?vue&type=style&index=0&id=a8195628&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8195628",
  null
  
)

export default component.exports